export { }
declare global {
    interface Array<T> {
        remove(elem: T): void
        orderBy(selector: (item: T) => any, direction?: 'asc' | 'desc'): T[]
    }
    interface String {
        limit(charLimit: number): string
    }
}

if (!Array.prototype.remove) {
    Array.prototype.remove = function <T>(elem: T) {
        const index = this.indexOf(elem)
        if (index !== -1) this.splice(index, 1)
    }
}

if (!Array.prototype.orderBy) {
    Array.prototype.orderBy = function <T>(
        this: T[],
        selector: (item: T) => any,
        direction: 'asc' | 'desc' = 'asc'
    ): T[] {
        return [...this].sort((a, b) => {
            const aValue = selector(a)
            const bValue = selector(b)
            if (aValue == null && bValue == null) return 0
            if (aValue == null) return direction === 'asc' ? 1 : -1
            if (bValue == null) return direction === 'asc' ? -1 : 1
            if (aValue < bValue) return direction === 'asc' ? -1 : 1
            if (aValue > bValue) return direction === 'asc' ? 1 : -1
            return 0
        })
    }
}

if (!String.prototype.limit) {
    String.prototype.limit = function (charLimit: number) {
        if (this.length > charLimit) return this.substring(0, charLimit - 3) + '...'
        return this.substring(0, charLimit)
    }
}
